import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
var EMPTY = {};
export default function shallowEqual() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY;
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY;
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  return a === b || aKeys.length === bKeys.length && aKeys.every(function (key) {
    return a[key] === b[key];
  });
}